import { AlertCircle, MessageCircle } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const ExitModal = ({ open, onOpenChange, onWhatsApp }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-gradient-to-b from-white to-gray-50 border-4 border-[#FFDF00]">
        <div className="text-center py-4">
          <div className="w-16 h-16 rounded-full bg-[#FFDF00] flex items-center justify-center mx-auto mb-3">
            <AlertCircle className="w-8 h-8 text-[#002776]" />
          </div>
          <h2 className="font-heading text-2xl text-[#002776] mb-2">
            ESPERA! 🇧🇷
          </h2>
          <p className="text-gray-600 text-sm mb-4">
            Não vai embora sem garantir seu voucher do <strong>PRIMEIRO LOTE</strong>!
          </p>
          
          <div className="bg-[#002776] rounded-2xl p-4 mb-4 text-white">
            <p className="text-xs mb-1">Use o cupom e ganhe</p>
            <p className="font-heading text-3xl text-[#FFDF00]">R$20 OFF</p>
            <div className="bg-white/20 rounded-lg px-4 py-2 mt-2 inline-block">
              <code className="font-bold text-lg tracking-wider">HEXA20</code>
            </div>
          </div>
          
          <p className="text-xs text-gray-500 mb-3">
            Mencione no WhatsApp e pague apenas <strong className="text-[#009C3B]">R$227 para 2 pessoas</strong>!
          </p>
          
          <Button 
            onClick={() => {
              onOpenChange(false);
              onWhatsApp("Oi! Vi o Desafio do Hexa e quero usar o cupom HEXA20 para garantir meu voucher do PRIMEIRO LOTE para 2 pessoas! 🇧🇷");
            }}
            className="w-full bg-[#25D366] hover:bg-[#20BD5A] text-white font-bold py-4 rounded-full flex items-center justify-center gap-2"
          >
            <MessageCircle className="w-5 h-5" />
            GARANTIR MEU VOUCHER
          </Button>
          
          <button 
            onClick={() => onOpenChange(false)}
            className="mt-2 text-gray-400 text-xs hover:text-gray-600"
          >
            Não, obrigado
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ExitModal;
